import { useEffect } from "react";
import { format } from "date-fns";
import { t } from "@/i18n-js/instance";
import { useCurrentPlanApi } from "@/react/components/SettingsApp/Plan/hooks/useCurrentPlanApi";
import { usePunditUserContext } from "@/react/contexts/punditUserContext";
import { Button } from "@circle-react-uikit/Button";
import { Modal } from "@circle-react-uikit/ModalV2";
import { Typography } from "@circle-react-uikit/Typography";

export interface PlanDowngradeScheduleSuccessProps {
  buttonLabel?: string;
  isPlanActionDowngrade?: boolean;
  onSuccess: () => void;
}

export const PlanDowngradeScheduleSuccess = ({
  buttonLabel,
  onSuccess,
  isPlanActionDowngrade = false,
}: PlanDowngradeScheduleSuccessProps) => {
  const { currentCommunity } = usePunditUserContext();
  const { refetchCurrentPlan } = useCurrentPlanApi();

  useEffect(() => {
    void refetchCurrentPlan();
  }, [refetchCurrentPlan]);

  const formattedDate = format(
    new Date(currentCommunity?.subscription.current_period_end || new Date()),
    "MMM dd, yyyy",
  );

  const i18nRoot = "pricing_plans.upgrade_modal.post_plan_update";
  const i18nSuffix = isPlanActionDowngrade
    ? "scheduled_downgrade"
    : "scheduled_interval_downgrade";

  return (
    <>
      <Modal.Body>
        <div className="mt-16 text-center">
          <Typography.TitleXl color="text-darkest">
            {t([i18nRoot, "header", i18nSuffix])}
          </Typography.TitleXl>
          <div className="mt-6">
            <Typography.BodyMd color="text-primary">
              {t([i18nRoot, "subheading", i18nSuffix])}{" "}
              <strong>{formattedDate}.</strong>
            </Typography.BodyMd>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="mt-8">
        <Button variant="circle" large full onClick={onSuccess}>
          {buttonLabel}
        </Button>
      </Modal.Footer>
    </>
  );
};
